import { render, staticRenderFns } from "./ItemPlannerPrice.vue?vue&type=template&id=71f201c0&"
import script from "./ItemPlannerPrice.vue?vue&type=script&lang=js&"
export * from "./ItemPlannerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports